import React from "react"
import { ErrorPage as ErrorPageC } from "@theguarantors/ui-kit-v2/dist/layout/pages/ErrorPage"
import { Application } from "@theguarantors/ui-kit-v2/dist"
import { defaultMenuItems } from "../../constants/menu"

interface Props {
  errorMessage: string | null
}

const reloadPage = () => window.location.reload()

export const ErrorPage: React.FC<Props> = ({ errorMessage }) => (
  <Application headerMenuItems={defaultMenuItems} data-testid="error-page">
    <ErrorPageC errorMessage={errorMessage} onClickBack={reloadPage} />
  </Application>
)
